import React from "react";
import PropTypes from "prop-types";
// import WrapperHeader from "components/Header/Wrapper";
import styled from "styled-components";
import SidebarWrapper from "./SidebarWrapper";


const Img = styled.img`
    position: absolute;
    right: 0;
    bottom: 0;
    max-width: 82%;
`
const ImgTopFrame = styled.img`
    position: absolute;
    right: 0;
    top: 0;
    max-width: 160px;
`
const ImgBottomFrame = styled.img`
    position: absolute;
    left: 0;
    bottom: 0;
    max-width: 162px;
`

const Container = styled.div`
    height: 100vh;
    width: 100vw;
    margin: 0;
    @media only screen and (max-width: 1024px) {
        display: block !important;
    }
`

const Children = styled.div`
    @media only screen and (max-width: 1024px) {
        min-height: auto !important;
        padding-block: 12px;
    }
`

const LayoutV2 = (props) => {
    const { children } = props;
    return (
        <Container className="row">
            <div className="d-flex col-12 col-md-6">
                {/* <WrapperHeader typeAuth>
                    <Logo src={require("_assets/images/logo-oca-white.svg").default} />
                </WrapperHeader> */}
                <Children className="d-flex flex-row height-with-header mx-auto w-100">
                    {children}
                </Children>
            </div>
            <SidebarWrapper className="col-12 col-md-6 mx-auto justify-content-center align-items-center flex-column position-relative">
                <Img src={require("_assets/icons/side-right-login.svg").default} style={{ resize: "" }} />
                <h1 className="margin-bottom-10 cl-white fsize-32 fweight-600 text-left">Dashboard API</h1>
                <p className="cl-white fsize-14 fweight-400 text-left">Keep track of your API usage and hit rate, create API monitoring reports, and use WhatsApp templates to send messages. </p>
                <ImgTopFrame className="" src={require("_assets/icons/frame-login-top.svg").default} style={{ resize: "" }} alt="" />
                <ImgBottomFrame src={require("_assets/icons/frame-login-bottom.svg").default} style={{ resize: "" }} alt="" />
            </SidebarWrapper>
        </Container>
    );
};

LayoutV2.propTypes = {
    children: PropTypes.node.isRequired,
};

export default LayoutV2;
